// extracted by mini-css-extract-plugin
module.exports = {"root":"LoadingAlert_root__1AIGi","content":"LoadingAlert_content__3HiNC"};